import { render, staticRenderFns } from "./EiHeadInfo.vue?vue&type=template&id=c0cc34e6&scoped=true&"
import script from "./EiHeadInfo.vue?vue&type=script&lang=js&"
export * from "./EiHeadInfo.vue?vue&type=script&lang=js&"
import style0 from "./EiHeadInfo.vue?vue&type=style&index=0&id=c0cc34e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0cc34e6",
  null
  
)

export default component.exports